// Theme: hologram-glass
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'hologram-glass',
  name: 'HOLOGRAM GLASS',
  tagline: 'HOLOGRAM GLASS',
  description: 'Recolor glass azul do hologram com mesma estrutura epica base.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#121524', '#BAE6FD', '#1E2540', '#E2ECFF'],
  familyId: 'hologram',
  variantName: 'GLASS',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-mono theme-hologram-glass'
  },
  colorVars: {
    '--accent': '#BAE6FD',
    '--accent-foreground': '#121524',
    '--background': '#121524',
    '--border': '#2A4A8A',
    '--card': '#1E2540',
    '--card-border-active': 'rgba(186, 230, 253, 0.48)',
    '--card-completed': '#1E2540',
    '--card-foreground': '#E2ECFF',
    '--card-glow': 'rgba(186, 230, 253, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#121524',
    '--foreground': '#E2ECFF',
    '--hold-fill': '#BAE6FD',
    '--input': '#1E2540',
    '--modal-bg': '#121524',
    '--modal-border': '#2A4A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A4A8A',
    '--muted-foreground': '#E2ECFF',
    '--nav-active': '#BAE6FD',
    '--nav-bg': '#121524',
    '--popover': '#1E2540',
    '--popover-foreground': '#E2ECFF',
    '--primary': '#BAE6FD',
    '--primary-foreground': '#121524',
    '--ring': '#BAE6FD',
    '--secondary': '#2A4A8A',
    '--secondary-foreground': '#E2ECFF',
    '--streak': '#BAE6FD',
    '--success': '#22C55E',
    '--success-foreground': '#121524',
    '--xp': '#BAE6FD',
    '--xp-bg': '#1E2540'
  },
  resolvedVars: {
    '--accent': '#BAE6FD',
    '--accent-foreground': '#121524',
    '--accent-foreground-hsl': '230 33% 11%',
    '--accent-foreground-oklch': 'from #121524 l c h',
    '--accent-hsl': '201 94% 86%',
    '--accent-oklch': 'from #BAE6FD l c h',
    '--background': '#121524',
    '--background-hsl': '230 33% 11%',
    '--background-oklch': 'from #121524 l c h',
    '--border': '#2A4A8A',
    '--border-hsl': '220 53% 35%',
    '--border-oklch': 'from #2A4A8A l c h',
    '--border-w': '1px',
    '--card': '#1E2540',
    '--card-border-active': 'rgba(186, 230, 253, 0.48)',
    '--card-completed': '#1E2540',
    '--card-completed-hsl': '228 36% 18%',
    '--card-completed-oklch': 'from #1E2540 l c h',
    '--card-foreground': '#E2ECFF',
    '--card-foreground-hsl': '219 100% 94%',
    '--card-foreground-oklch': 'from #E2ECFF l c h',
    '--card-glow': 'rgba(186, 230, 253, 0.1)',
    '--card-hsl': '228 36% 18%',
    '--card-oklch': 'from #1E2540 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#121524',
    '--destructive-foreground-hsl': '230 33% 11%',
    '--destructive-foreground-oklch': 'from #121524 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#E2ECFF',
    '--foreground-hsl': '219 100% 94%',
    '--foreground-oklch': 'from #E2ECFF l c h',
    '--hold-fill': '#BAE6FD',
    '--hold-fill-hsl': '201 94% 86%',
    '--hold-fill-oklch': 'from #BAE6FD l c h',
    '--input': '#1E2540',
    '--input-hsl': '228 36% 18%',
    '--input-oklch': 'from #1E2540 l c h',
    '--modal-bg': '#121524',
    '--modal-bg-hsl': '230 33% 11%',
    '--modal-bg-oklch': 'from #121524 l c h',
    '--modal-border': '#2A4A8A',
    '--modal-border-hsl': '220 53% 35%',
    '--modal-border-oklch': 'from #2A4A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A4A8A',
    '--muted-foreground': '#E2ECFF',
    '--muted-foreground-hsl': '219 100% 94%',
    '--muted-foreground-oklch': 'from #E2ECFF l c h',
    '--muted-hsl': '220 53% 35%',
    '--muted-oklch': 'from #2A4A8A l c h',
    '--nav-active': '#BAE6FD',
    '--nav-active-hsl': '201 94% 86%',
    '--nav-active-oklch': 'from #BAE6FD l c h',
    '--nav-bg': '#121524',
    '--nav-bg-hsl': '230 33% 11%',
    '--nav-bg-oklch': 'from #121524 l c h',
    '--popover': '#1E2540',
    '--popover-foreground': '#E2ECFF',
    '--popover-foreground-hsl': '219 100% 94%',
    '--popover-foreground-oklch': 'from #E2ECFF l c h',
    '--popover-hsl': '228 36% 18%',
    '--popover-oklch': 'from #1E2540 l c h',
    '--primary': '#BAE6FD',
    '--primary-foreground': '#121524',
    '--primary-foreground-hsl': '230 33% 11%',
    '--primary-foreground-oklch': 'from #121524 l c h',
    '--primary-hsl': '201 94% 86%',
    '--primary-oklch': 'from #BAE6FD l c h',
    '--radius': '12px',
    '--ring': '#BAE6FD',
    '--ring-hsl': '201 94% 86%',
    '--ring-oklch': 'from #BAE6FD l c h',
    '--secondary': '#2A4A8A',
    '--secondary-foreground': '#E2ECFF',
    '--secondary-foreground-hsl': '219 100% 94%',
    '--secondary-foreground-oklch': 'from #E2ECFF l c h',
    '--secondary-hsl': '220 53% 35%',
    '--secondary-oklch': 'from #2A4A8A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#BAE6FD',
    '--streak-hsl': '201 94% 86%',
    '--streak-oklch': 'from #BAE6FD l c h',
    '--success': '#22C55E',
    '--success-foreground': '#121524',
    '--success-foreground-hsl': '230 33% 11%',
    '--success-foreground-oklch': 'from #121524 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(201 94% 86% / 0.15)',
    '--xp': '#BAE6FD',
    '--xp-bg': '#1E2540',
    '--xp-bg-hsl': '228 36% 18%',
    '--xp-bg-oklch': 'from #1E2540 l c h',
    '--xp-hsl': '201 94% 86%',
    '--xp-oklch': 'from #BAE6FD l c h'
  }
}
